import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, QuestionAwnserReducer, QuestionAwnserState } from './question-awnser-reducer';


const QuestionAwnserContext = createContext<QuestionAwnserState | undefined>(undefined);
const QuestionAnwserContextDispatchContext = createContext({} as any);

const QuestionAwnserProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(QuestionAwnserReducer, {} as QuestionAwnserState);

    return (
        <QuestionAwnserContext.Provider value={state}>
            <QuestionAnwserContextDispatchContext.Provider value={dispatch}>
                {children}
            </QuestionAnwserContextDispatchContext.Provider>
        </QuestionAwnserContext.Provider>
    );
}

const useQuestionAwnserState = () => {
    const context = useContext(QuestionAwnserContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useQuestionAwnserDispatch = () => {
    const context = useContext(QuestionAnwserContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { QuestionAwnserProvider, useQuestionAwnserState, useQuestionAwnserDispatch, ACTION_TYPES };

